import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router'
import './App.css'
import Start from './pages/Start/Start'
import Quiz from './pages/Quiz/Quiz'
import { UserDataProvider } from './providers/UserDataProvider/Provider'
import Age from './pages/Age/Age'
import { TextPages } from './pages/TextPages/TextPages'
import { QuizLayout } from './pages/Quiz/QuizLayout';
import Paywall from './pages/Paywall/Paywall'
// import {RegistrationLayout} from './pages/Registration/RegistrationLayout'
// import Registration from './pages/Registration/Registration'
import { Email } from './pages/Paywall/Sections/Email/Email'
import { RegistrationWithProvider } from './pages/Registration/RegistrationWithProvider'
import { Gender } from './pages/Gender/Gender'
import { useEffect } from 'react'
import { saveUtmParamsOnce } from './services/utmHelpers'
import { saveReferpulseAttributionOnce } from './services/referpulseAttribution'
import { getDataUrl } from './utils/getDataUrl'
import i18n from './services/i18n'
import { CurrencyProvider } from './providers/CurrencyProvider/Provider'
import * as amplitude from '@amplitude/analytics-browser';
export function RegistrationIndexRedirect() {
  const location = useLocation();
  return (
    // QA-97: the app account comes first, right after the payment; the upsells follow it.
    <Navigate to={`/registration/create/${location.search}`} replace />
  );
}
// const amplitudeApiKey = import.meta.env.VITE_AMPLITUDE_API_KEY;
function App() {
  useEffect(() => {
    saveUtmParamsOnce();
    saveReferpulseAttributionOnce();
    amplitude.init('3eca574ab9546ec8b20de8f5a9fc2f8c',  { "fetchRemoteConfig": true, "autocapture": {
      elementInteractions: false,
      pageViews: false,
    }})
    const baseUrl = window.location.origin + window.location.pathname;
    const identifyEvent = new amplitude.Identify();
    identifyEvent.set('urlDomain', baseUrl);
    amplitude.identify(identifyEvent);
  }, []);
  
  return (
    <UserDataProvider>
      <Routes>
        <Route index element={<Start dataUrl={getDataUrl('Start.json')}/>} />
        <Route path="/gender/" element={<Gender  dataUrl={getDataUrl('Gender.json')}/>} />
        <Route path="/age/" element={<Age dataUrl={getDataUrl('Age.json')}/>} />
        <Route path="/quiz/" element={<QuizLayout />}>
          <Route index element={<Navigate to="/quiz/1" replace />} />
          <Route path=":id" element={<Quiz />} />
        </Route>
        <Route path="/menu/:page" element={<TextPages theme="light" dataUrl="/Data/text-pages/"/>} />
        <Route path="/email/" element={<Email dataUrl={getDataUrl('Email.json')}/>} />
        <Route path="/paywall/" element={<CurrencyProvider><Paywall dataUrl={getDataUrl(import.meta.env.VITE_PAYWALL_FILE)}/></CurrencyProvider>} />
        <Route path="/registration/" element={<Outlet />}>
          <Route index element={<RegistrationIndexRedirect/>} />
          <Route path=":id" element={<RegistrationWithProvider theme="light" dataUrl={getDataUrl(import.meta.env.VITE_REGISTRATION_FILE)}/>} />
        </Route>
        <Route path="/:creatorSlug" element={<Start dataUrl={getDataUrl('Start.json')}/>} />
      </Routes>
    </UserDataProvider >
  )
}

export default App
